import React,{useState} from 'react'
import {firestore} from '../firebase/firebase.utils'

export default function Redeem({user}) {
    const [s,setS] = useState({amount:0,text:''})
    const {amount,text} = s
    const numberChange = (event) =>{
        setS({amount:event.target.value,text:text})
    }
    const textChange = (event) =>{
        setS({amount:amount,text:event.target.value})
    }
    const onRedeem = (amount) =>{
        var c = {}
        var docId = ''
        firestore.collection("users").where('email','==',user.email).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(async function(doc) {
                    c = doc.data()
                    docId = doc.id;
                });
                let ad = parseInt(c.entries) - parseInt(amount)
                firestore.collection("users").doc(docId).set({
                    id: c.id,
                    name: c.name,
                    email: c.email,
                    entries: ad,
                    joined: c.joined,
                    isBlocked: c.isBlocked,
                    receivedRequests: c.receivedRequests,
                    sentRequests : c.sentRequests
                })
                .then(function() {
                    console.log("");
                    })
                    fetch('https://us-central1-vqpoints.cloudfunctions.net/api/sendredeememail',{
						method:'post',
						headers: {'Content-Type': 'application/json'},
						body: JSON.stringify({
							id: user.email,
							points: parseInt(amount),
                            text: text
						})
					  })
					  .then(respone=>respone.json())
					  .then(res =>{
						// console.log('complete')
                    alert("We have recieved your request and will get back to you soon")
					  })
                })
                .catch(function(error) {
                    alert("Request Failed")
                });
        }
    return(
        <div className="pa3 ba b--near-white bw2">
					<h1 className="white">Redeem Points</h1>
					<input 
						type='tel'
						className='pa3 ml3 ba b--green bg-lightest-blue' 
						placeholder='Enter Amount'
						onInput = {numberChange}
						min="0"
					/>
										<input 
						type='text'
						className='pa3 ml3 ba b--green bg-lightest-blue' 
						placeholder='Message...'
						onInput = {textChange}
					/>
					{
						amount>0 && amount<=user.entries
					?<input
                		className="b ph3 pv2 ml2 input-reset ba b--white white bg-green grow pointer f4 dib"
                		type="submit"
                		value="Complete Transfer"
                		onClick={()=>onRedeem(amount)}
              		/>
              		:<div className="f4 white pa3 ">Amount is greater than your current balance or Equal to Zero</div>
              	}
                  <h2 style={{color:"white",textAlign:"left"}}>Note:</h2>
                  <p style={{color:"white",textAlign:"left"}}>
                  What you should include in your message. 
                  <br/>
1.  Apple pay ( Email, Number)
<br/>

2. Cash app(Users name, Email, Number) 
<br/>

3. MoneyGram. (First and last, sending location)  
<br/>

4. PayPal (Users name, Email, Number) 
<br/>

5. Venmo (Users name, Email, Number) 
<br/>

6. western union(First and last, sending location) 
<br/>

7. Zelle( Email, Number)
                  </p>
                  </div>
    );
}
